import React from 'react';
import { StyledSystemProps } from '@creditas-ui/react';
import { OptionItem } from './ProfileOptionItem.style';

interface ProfileOptionItemBaseProps {
  children: React.ReactNode;
}

type ProfileOptionItemElProps = React.HTMLAttributes<HTMLDivElement>;

type ProfileOptionItemProps = ProfileOptionItemBaseProps &
  ProfileOptionItemElProps &
  StyledSystemProps;

const ProfileOptionItem = ({ children, ...props }: ProfileOptionItemProps): JSX.Element => (
  <OptionItem {...props}>{children}</OptionItem>
);

export { ProfileOptionItem };
